import { ActionReducer, MetaReducer } from '@ngrx/store';
import { State } from '../../main';
import * as AuthActions from '@app/store/features/auth/auth.actions';
import * as WebSocket from '@app/store/features/web-socket/web-socket.reducer';
import * as WebSocketActions from '@app/store/features/web-socket/web-socket.actions';

import * as Config from '@app/store/features/config/config.reducer';
import * as ConfigActions from '@app/store/features/config/config.actions';
import * as Auth from '@app/store/features/auth/auth.reducer';
import { ConnectionStatus } from '@app/enums/connection-status';


export function clearStateMetaReducer(reducer: ActionReducer<State>): ActionReducer<State> {
    return (state, action) => {
        if (action.type === AuthActions.onLogout.type) {

            const preservedConfigState = state!.config;


            // console.log("STATE CLEAN UP 🧹🗑️🧽🧼")
            state = {
                ws: undefined as unknown as WebSocket.State,
                auth: undefined as unknown as Auth.State,
                main: undefined,
                config: {
                    ...preservedConfigState,

                    casinosInfo: [],
                    jackPotsInfo: [],

                    appReadyToUse: false,

                    globalSettings: null,
                    skinSettings: null,
                    authSettings: null,
                }
            }
        } else if (action.type === WebSocketActions.updateConnectionStatus.type) {
            const { status } = action as ReturnType<typeof WebSocketActions.updateConnectionStatus>;
            if (status === ConnectionStatus.Offline || status === ConnectionStatus.Disconnected) {
                // Keep authSettings on config state to allow reconnect
                const preservedConfigState = state!.config;

                state = {
                    ws: undefined as unknown as WebSocket.State,
                    auth: undefined as unknown as Auth.State,
                    main: undefined,
                    config: {
                        ...preservedConfigState,

                        casinosInfo: [],
                        jackPotsInfo: [],

                        appReadyToUse: false,

                        globalSettings: null,
                        skinSettings: null,
                    }
                }
            }
        }
        return reducer(state, action);
    };
}
